import React from 'react'
export interface DebugLogEntry {
  id: string
  source: string // e.g. 'jira', 'github', 'api'
  tool: string // API tool name or endpoint
  params: any
  rawResponse: any // Raw server response
  processedData: any // After unwrap/processing
  success: boolean
  error?: string
  timestamp: string // ISO string
  durationMs?: number
}
export interface DebugAction {
  id: string
  label: string
  icon: React.ElementType
  color: string // Tailwind text color class e.g. 'text-blue-400'
  bgColor: string // Tailwind bg color class e.g. 'bg-blue-500/10'
  hoverBgColor: string // Tailwind hover bg class e.g. 'hover:bg-blue-500/20'
  handler: (log: DebugLogEntry) => Promise<void> | void
  visible?: (log: DebugLogEntry) => boolean
}
export interface DebugSourceConfig {
  bg: string
  text: string
}
export interface DebugConfig {
  maxLogs?: number
  shortcut?: string // e.g., 'ctrl+shift+d' (currently hardcoded to this in provider)
  sources?: Record<string, DebugSourceConfig>
  actions?: DebugAction[]
}
